import axios from 'axios';
import authHeader from './auth-header';
import BasicService from './basic.service'

class AnnouncementsService extends BasicService {
    getAll() {
        return this.checkError(axios.get(this.API_URL + 'announcements', { headers: authHeader() }));
    }

    save(data) {
        data.duration = Number(data.duration);
        return this.checkError(axios.post(this.API_URL + 'announcements', data, { headers: authHeader() }));
    }

    view(data) {
        return this.checkError(axios.post(this.API_URL + 'announcements/view', data, { headers: authHeader() }));
    }

    delete(id) {
        return this.checkError(axios.delete(this.API_URL + 'announcements/' + id, { headers: authHeader() }));
    }
}

export default new AnnouncementsService();